// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#fireLightMainDiv .navigationButtonsContainer {
  display: none !important;
}

#fireLightMainDiv .ITWizardRoot {
  width: auto;
}

#fireLightMainDiv .ITComponent > div {
  height: auto !important;
}
`, "",{"version":3,"sources":["webpack://./app/css/firelight.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;AAC1B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,uBAAuB;AACzB","sourcesContent":["#fireLightMainDiv .navigationButtonsContainer {\n  display: none !important;\n}\n\n#fireLightMainDiv .ITWizardRoot {\n  width: auto;\n}\n\n#fireLightMainDiv .ITComponent > div {\n  height: auto !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
